import { lazy } from "react";
import Loadable from "app/components/Loadable";
import OperationalRouteGuard from "app/components/operational-workspace/OperationalRouteGuard";

const PatientVisitList = Loadable(lazy(() => import("./PatientVisitList")));

const PatientVisitListRoutes = [
  {
    path: "/patients/visits",
    element: (
      <OperationalRouteGuard moduleId="DOCTOR_CONSULTATION">
        <PatientVisitList />
      </OperationalRouteGuard>
    ),
  },
];

export default PatientVisitListRoutes;
